<h4 *ngIf="isTemplateMissing">
    Invoice Template Not Found<br />Ask an account admin to create one.
</h4>
<!-- <div [innerHtml]="invoiceHtml"></div> -->
<div class="flex justify-end gap-4">
    <button nz-button (click)="openWindow()" nzType="dashed">
        Print/PDF <i class="fa-solid fa-arrow-up-right-from-square ml-2"></i>
    </button>
    <button nz-button (click)="confirmEmailToPatient()" nzType="dashed">
        Email to <i class="fa-solid fa-paper-plane ml-2"></i>
    </button>
</div>

<nz-modal
    [(nzVisible)]="isVisible"
    nzTitle="Send Invoice"
    (nzOnCancel)="handleCancel()"
    (nzOnOk)="handleOk()"
>
    <ng-container *nzModalContent>
        <nz-form-item>
            <nz-form-label>Email</nz-form-label>
            <nz-form-control>
                <input
                    nz-input
                    [formControl]="emailControl"
                    name="email"
                    type="email"
                    placeholder="Enter email address"
                />
            </nz-form-control>
        </nz-form-item>
    </ng-container>
</nz-modal>

<div #htmlViewer></div>
<!-- <embedded-webview [html]="invoiceHtml"></embedded-webview> -->
<!-- <div>{{ invoice | json }}</div> -->
